import { esc } from './ui'

const GREEN = '#2F6B34'
const SOFT = '#E6F0E1'

/** แถบแนวนอน — เหมาะกับ label ไทยยาว ๆ  rows: [label, value, note?] */
export function hbars(rows: [string, number, string?][], opts: { unit?: string } = {}): string {
  if (!rows.length) return `<p class="muted-sm">ไม่มีข้อมูล</p>`
  const max = Math.max(...rows.map((r) => r[1]), 1)
  return `<div class="hbars">${rows
    .map(
      ([label, val, note]) => `<div class="hb">
        <div class="hb-top"><span>${esc(label)}</span><b>${val.toLocaleString('th-TH')}${
          opts.unit ? ' ' + esc(opts.unit) : ''
        }${note ? ` <i>${esc(note)}</i>` : ''}</b></div>
        <div class="hb-track"><div class="hb-fill" style="width:${(val / max) * 100}%"></div></div>
      </div>`,
    )
    .join('')}</div>`
}

/** กราฟเส้นแนวโน้ม — points: [label, value][] */
export function trend(points: [string, number][], opts: { height?: number; noun?: string } = {}): string {
  if (points.length < 2) return `<p class="muted-sm">ข้อมูลน้อยเกินไปสำหรับกราฟ</p>`
  const W = 320
  const H = opts.height ?? 90
  const pad = 6
  const max = Math.max(...points.map((p) => p[1]), 1)
  const dx = (W - pad * 2) / (points.length - 1)
  const xy = points.map((p, i) => [pad + i * dx, H - pad - (p[1] / max) * (H - pad * 2)] as const)
  const line = xy.map(([x, y], i) => `${i ? 'L' : 'M'}${x.toFixed(1)} ${y.toFixed(1)}`).join(' ')
  const area = `${line} L${xy[xy.length - 1]![0].toFixed(1)} ${H - pad} L${xy[0]![0].toFixed(1)} ${H - pad} Z`
  const noun = opts.noun ?? 'เรื่อง'
  const total = points.reduce((s, p) => s + p[1], 0)
  const peak = points.reduce((a, b) => (b[1] > a[1] ? b : a))
  return `
    <svg class="trend" viewBox="0 0 ${W} ${H}" preserveAspectRatio="none" role="img">
      <path d="${area}" fill="${SOFT}"/>
      <path d="${line}" fill="none" stroke="${GREEN}" stroke-width="2" stroke-linejoin="round"/>
    </svg>
    <p class="muted-sm">รวม ${total.toLocaleString('th-TH')} ${esc(noun)} · สูงสุด ${peak[1]} (${peak[0].slice(5)})</p>`
}
